export var PREFIX_CLS = 'ant-fullcalendar';


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/calendar/Constants.js
// module id = 272
// module chunks = 0